import { Button, Spinner, Tooltip } from '@material-tailwind/react'
import { size } from '@material-tailwind/react/types/components/button';
import { useState, forwardRef } from 'react'

const DownloadBtnLarge = ({
    handleDownloadFile,
    record,
    text,
    icon,
    className,
    size,
    disabled,
}: {
    handleDownloadFile: any,
    record?: any,
    text?: string,
    icon?: any,
    className?: string,
    size?: size,
    disabled?: boolean
}) => {

    const [isLoading, setIsLoading] = useState<boolean>(false);


    return (
        <Button
            color="black"
            size={size}
            disabled={disabled}
            className={`w-full tab:w-auto text-[12px] mob:text-[14px] tab:text-[16px] flex items-center gap-[4px] ${className}`}
            onClick={(event: any) => {
                event.stopPropagation()
                setIsLoading(true)
                handleDownloadFile(record, () => {
                    setIsLoading(false)
                })
            }}
        >
            {
                isLoading ?
                    <Spinner className='h-[1rem]' />
                    :
                    icon ? icon : ''
            }
            <span >{text}</span>
        </Button>
    )
}

export default DownloadBtnLarge
